import PropTypes from "prop-types";

import { Chip, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { statusColors, statusLabels } from "@/features/goods-receipts";
import { formatDate } from "@/features/shared";

export const GeneralInformationSection = ({ goodsReceipt }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Umum</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Status
          </Typography>
          {goodsReceipt.status && (
            <Chip
              label={statusLabels[goodsReceipt.status]}
              color={statusColors[goodsReceipt.status]}
              size="small"
            />
          )}
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Dibuat oleh
          </Typography>
          <Typography variant="body1">
            {goodsReceipt.creator?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Tanggal Transaksi
          </Typography>
          <Typography variant="body1">
            {formatDate(goodsReceipt.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Pemasok
          </Typography>
          <Typography variant="body1">
            {goodsReceipt.seller?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Outlet
          </Typography>
          <Typography variant="body1">
            {goodsReceipt.buyer?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Gudang
          </Typography>
          <Typography variant="body1">
            {goodsReceipt.warehouse?.name || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            No. Surat Jalan
          </Typography>
          <Typography variant="body1">
            {goodsReceipt.sellerReferenceNumber || "-"}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            Catatan
          </Typography>
          <Typography variant="body1">{goodsReceipt.note ?? "-"}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

GeneralInformationSection.propTypes = {
  goodsReceipt: PropTypes.object.isRequired,
};
